<template>
  <div v-if="isFullScreen">
    <transition name="van-slide-left">
      <div v-show="!video.isLive && controlBarShow" class="videoscreencontrol" id="videoscreencontrol">
        <i v-if="!video.videoisPlaying" @click="videoControl(true)" class="iconfont iconicon_play"></i>
        <i v-else @click="videoControl(false)" class="iconfont iconzanting"></i>
        <van-slider
          vertical
          style="margin:20px 0"
          @drag-start="dragStart"
          @change="dragChange"
          @drag-end="dragEnd"
          :max="videoDuration"
          v-model="videoTime"
          button-size="12px"
        />
        <i @click="handle2FullScreen" class="iconfont iconquanping"></i>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['videoDuration', 'videoCurrent'],
  data() {
    return {
      controlBarShow: true,
      videoTime: 0,
      isDraging: false
    }
  },
  watch: {
    videoCurrent(val) {
      if (!this.isDraging) {
        this.videoTime = val
      }
    },
    isFullScreen(val) {
      if (val) {
        this.set3sHide()
      }
    }
  },
  computed: {
    video() {
      return this.$store.state.activePlay.video
    },
    isFullScreen() {
      return this.$store.state.activePlay.isFullScreen
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', () => {
      this.showControlBar()
    })
  },
  mounted() {
    document.addEventListener('click', () => {
      this.showControlBar()
    })
  },
  methods: {
    showControlBar() {
      this.controlBarShow = true
      this.set3sHide()
    },
    set3sHide() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.controlBarShow = false
      }, 3000)
    },
    handle2FullScreen() {
      const mainPlayerContainer = document.getElementById('videoContainer')
      mainPlayerContainer.style.width = ''
      mainPlayerContainer.style.height = ''
      mainPlayerContainer.style.zIndex = ''
      mainPlayerContainer.style.transform = ''
      this.$store.commit('toggleFullScreen')
      this.$emit('restScreen', this.isFullScreen)
    },
    videoControl(flag) {
      this.$emit('videoPlayOrPause', flag)
    },
    dragStart() {
      this.isDraging = true
    },
    dragChange(value) {
      this.$emit('videoCurrentTimeChange', value)
    },
    dragEnd() {
      this.$emit('videoCurrentTimeChange', this.videoTime)
      this.isDraging = false
    }
  }
}
</script>

<style scoped lang="scss">
.videoscreencontrol {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 99999;
  width: 40px;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  i {
    color: #fff;
    font-size: 20px;
    display: inline-block;
    transform: rotate(90deg);
  }
}
</style>
